__turbopack_context__.v({
  "button": "style-module-scss-module__B9KTcq__button",
  "input": "style-module-scss-module__B9KTcq__input",
  "search": "style-module-scss-module__B9KTcq__search",
});
